// import copy from 'fast-copy';
// import Member from 'ocus-shared-resources/src/Domains/Member/Member';

export const state = () => ({
  me: null,
  user: null,
});

/*
export const getters = {
  me: (state) => {
    if (!state.me) return null;

    return new Member(copy(state.me));
  },
  user: (state) => {
    if (!state.me) return null;

    return copy(state.me);
  },
};
*/

/*
export const actions = {
  async set({ commit }, user = {}) {
    commit('setUser', user);
  },
};
*/

export const mutations = {
  setUser(state, user) {
    state.me = user;
  },
};
